// extracted by mini-css-extract-plugin
module.exports = {"main":"layout-module--main--16IQX","mainContent":"layout-module--mainContent--3BU3W"};